export default "__VITE_ASSET__0cf4d52d__"